import React, { Component } from 'react';
import { View } from '../UIElements/All.js';
import { isRetail } from '../Managers/Utils';
// import Button from '@lightspeed/cirrus-button';

class ReUpButton extends Component {
  render() 
  {
    var style = {flex:-1, height:52, fontSize:20, borderRadius:4};

    if( this.props.enabled )
    {
      style.cursor = "pointer";
      if( this.props.type == 0 )
      {
        style.backgroundColor = this.props.colors.primaryBackground;
        style.color = this.props.colors.primaryText;
        style.borderColor = this.props.colors.primaryBorder;
      }
      else if( this.props.type == 1 )
      {
        style.backgroundColor = this.props.colors.secondaryBackground;
        style.color = this.props.colors.secondaryText;
        style.borderColor = this.props.colors.secondaryBorder;
      }
      else if( this.props.type == 2 )
      {
        style.backgroundColor = this.props.colors.tertiaryBackground;
        style.color = this.props.colors.tertiaryText;
        style.borderColor = this.props.colors.tertiaryBorder;
      }
      else if( this.props.type == 3 )
      {
        style.backgroundColor = this.props.colors.quaternaryBackground;
        style.color = this.props.colors.quaternaryText;
        style.borderColor = this.props.colors.quaternaryBorder;
      }
      else if( this.props.type == 4 )
      {
        style.backgroundColor = this.props.colors.background5;
        style.color = this.props.colors.text5;
        style.borderColor = this.props.colors.border5;
      }
      else if( this.props.type == 5 )
      {
        style.backgroundColor = this.props.colors.background6;
        style.color = this.props.colors.text6;
        style.borderColor = this.props.colors.border6;
      }
      
      style.borderWidth = 1.5;
      style.borderStyle = 'solid';
    }
    else
    {
      if( this.props.type == 0 )
      {
        style.backgroundColor = this.props.colors.primaryDisabledBackground;
        style.color = this.props.colors.primaryDisabledText;
        style.borderColor = this.props.colors.primaryBorder;
      }
      else if( this.props.type == 1 )
      {
        style.backgroundColor = this.props.colors.secondaryDisabledBackground;
        style.color = this.props.colors.secondaryDisabledText;
        style.borderColor = this.props.colors.secondaryBorder;
      }
      else if( this.props.type == 2 )
      {
        style.backgroundColor = this.props.colors.tertiaryDisabledBackground;
        style.color = this.props.colors.tertiaryDisabledText;
        style.borderColor = this.props.colors.tertiaryBorder;
      }
      else if( this.props.type == 3 )
      {
        style.backgroundColor = this.props.colors.quaternaryDisabledBackground;
        style.color = this.props.colors.quaternaryDisabledText;
        style.borderColor = this.props.colors.quaternaryBorder;
      }
      else if( this.props.type == 4 )
      {
        style.backgroundColor = this.props.colors.background5Disabled;
        style.color = this.props.colors.text5Disabled;
        style.borderColor = this.props.colors.border5Disabled;
      }
      else if( this.props.type == 5 )
      {
        style.backgroundColor = this.props.colors.background6Disabled;
        style.color = this.props.colors.text6Disabled;
        style.borderColor = this.props.colors.border6Disabled;
      }

      else if( this.props.type == 6 )
      {
        style.backgroundColor = this.props.colors.background7Disabled;
        style.color = this.props.colors.text7Disabled;
        style.borderColor = this.props.colors.border7Disabled;
      }

      style.borderWidth = 1.5;
      style.borderStyle = 'solid';
    }

    if( this.props.type != 3 ) style.boxShadow = "0 4px 8px 0 rgba(0, 0, 0, 0.08), 0 6px 20px 0 rgba(0, 0, 0, 0.07)";

    if( isRetail() ) style.width = 180;

    for( var key in this.props.style ) style[key] = this.props.style[key];

    var children = this.props.children;

    if( typeof children === 'string' || (typeof children.props !== 'undefined' &&  typeof children.props.locKey !== 'undefined'))
    {
      children = <View style={{alignSelf:'center', textAlign:'center', justifyContent:'center', fontSize:20}}>
          {this.props.children}
        </View>
    }

    var viewProps = {};
    if (this.props.enabled)
    {
      viewProps.onClick = this.props.onPress;
    }

    return (
      <View
        style={style}
        {...viewProps}
        >
        {children}
      </View>
    );
  }
}

ReUpButton.defaultProps = {
  style: {},
  type: 0,
  enabled: true,
  backgroundColor: 'transparent',
  foregroundColor: 'transparent',
  onPress: ()=>alert(1),
};

export default ReUpButton;